import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import RequireAdmin from "@/components/RequireAdmin";
import SiteLock, { useSiteLock } from "@/components/SiteLock";

import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ModulesListPage from "@/pages/ModulesListPage";
import ModuleDetailPage from "@/pages/ModuleDetailPage";
import LessonPage from "@/pages/LessonPage";
import QuizPage from "@/pages/QuizPage";
import PracticeExamIntroPage from "@/pages/PracticeExamIntroPage";
import TutorPage from "@/pages/TutorPage";
import FlashcardsPage from "@/pages/FlashcardsPage";
import VideoLibraryPage from "@/pages/VideoLibraryPage";
import MissedDrillIntroPage from "@/pages/MissedDrillIntroPage";
import { StudyKitIndex, StudyKitDoc } from "@/pages/StudyKitPages";
import AdminPage from "@/pages/AdminPage";
import CertificatePage from "@/pages/CertificatePage";

function LoginGate() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/dashboard" replace /> : <LoginPage />;
}

export default function App() {
  const { unlocked, unlock } = useSiteLock();
  if (!unlocked) return <SiteLock onUnlock={unlock} />;
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginGate />} />

            <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/modules" element={<ProtectedRoute><ModulesListPage /></ProtectedRoute>} />
            <Route path="/modules/:moduleId" element={<ProtectedRoute><ModuleDetailPage /></ProtectedRoute>} />
            <Route path="/modules/:moduleId/lesson/:lessonId" element={<ProtectedRoute><LessonPage /></ProtectedRoute>} />
            <Route path="/modules/:moduleId/quiz" element={<ProtectedRoute><QuizPage /></ProtectedRoute>} />
            <Route path="/modules/3/sample-test" element={<ProtectedRoute><QuizPage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><RequireAdmin><AdminPage /></RequireAdmin></ProtectedRoute>} />

            <Route path="/practice-exam" element={<ProtectedRoute><PracticeExamIntroPage /></ProtectedRoute>} />
            <Route path="/practice-exam/take" element={<ProtectedRoute><QuizPage /></ProtectedRoute>} />

            <Route path="/flashcards" element={<ProtectedRoute><FlashcardsPage /></ProtectedRoute>} />
            <Route path="/videos" element={<ProtectedRoute><VideoLibraryPage /></ProtectedRoute>} />
            <Route path="/study-kit" element={<ProtectedRoute><StudyKitIndex /></ProtectedRoute>} />
            <Route path="/study-kit/:slug" element={<ProtectedRoute><StudyKitDoc /></ProtectedRoute>} />
            <Route path="/missed-drill" element={<ProtectedRoute><MissedDrillIntroPage /></ProtectedRoute>} />
            <Route path="/missed-drill/take" element={<ProtectedRoute><QuizPage /></ProtectedRoute>} />

            <Route path="/certificate" element={<ProtectedRoute><CertificatePage /></ProtectedRoute>} />

            <Route path="/tutor" element={<ProtectedRoute><TutorPage /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
